import { render, staticRenderFns } from "./First.vue?vue&type=template&id=d38f42ea&"
import script from "./First.vue?vue&type=script&lang=js&"
export * from "./First.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports